'use client';

// import Loading from '@/app/[locale]/loading';
import { useFindByPostcodeQuery } from '@/lib/api';

import { useLocale, useTranslations } from 'next-intl';


import { useState } from 'react';
import FormPostcode, { ShowOptions } from './FormPostcode';

import Loading from '@/app/loading';
import { getTranslations, setRequestLocale } from 'next-intl/server';
import Map from './maps/Map';
import FetchBaseQueryAlert from './util/FetchBaseQueryAlert';


export interface ZorgZoekerProps {
	postcode?: string
}

export default function ZorgZoeker({ postcode }: ZorgZoekerProps) {
	const [currentPostcode, setCurrentPostcode] = useState(postcode || '');
	const t = useTranslations();
	const [show, setShow] = useState<ShowOptions>(ShowOptions.all);

	const [displayMap, setDisplayMap] = useState(false);

	const { data, error, isLoading, isError, isUninitialized } = useFindByPostcodeQuery(currentPostcode, { skip: !currentPostcode });


	// const locale = useLocale();

	return (
		<>
			<div className="card-form">
				{/* <h1>{locale}</h1> */}
				<h1>{t('Generic.HuisartsZoeker')}</h1>

				<FormPostcode postcode={currentPostcode} setPostcode={setCurrentPostcode} show={show} setShow={setShow} displayMap={displayMap} setDisplayMap={setDisplayMap} />

			</div>
			<div className="container">
				{isLoading && <Loading />}
				{isError && (
					<FetchBaseQueryAlert
						title={t("Generic.an-error-occurred")}
						error={error}
					/>
				)}
				{isError && <p>{t("Generic.no-data")}</p>}
				{!isError && !isLoading && !data && !isUninitialized && <p>{t("Generic.no-data")}</p>}
				{!isError && data && (
					<Map
						organisations={data.results}
						location={{ lat: data.location.lat, lng: data.location.lon }} // Default to Amsterdam
						type={show}
						displayMap={displayMap}
					/>
				)}

			</div>
		</>
	);
}
